import { render, staticRenderFns } from "./MusicDetailItem.vue?vue&type=template&id=0df0f508&scoped=true&"
import script from "./MusicDetailItem.vue?vue&type=script&lang=js&"
export * from "./MusicDetailItem.vue?vue&type=script&lang=js&"
import style0 from "./MusicDetailItem.vue?vue&type=style&index=0&id=0df0f508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df0f508",
  null
  
)

export default component.exports